// removed by extract-text-webpack-plugin
module.exports = {"forms":"c-MembershipForms__forms"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/MembershipForms/MembershipForms.scss
// module id = 950
// module chunks = 0